import { render } from "./CZExchangeRate.vue?vue&type=template&id=a275c1a2&ts=true"
import script from "./CZExchangeRate.vue?vue&type=script&lang=ts"
export * from "./CZExchangeRate.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__